export * from './DealOverlay';
export * from './DealOverlayBloc';
export * from './DealDetails';

import { openModal } from '@core/components/ModalStack';
import { DealOverlayProps } from './DealOverlay';

export async function openDealOverlay(props: DealOverlayProps) {
  const { DealOverlay } = await import('./DealOverlay');

  openModal(DealOverlay, props);
}
